import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const PasswordService = {
  forgetPassword: async (data) => {
    const payload = { email: data };
    const response = await apiService.post(
      "/customers/forgot-password",
      payload
    );
    return response.data;
  },

  resetPassword: async (resetCode, newPassword, confirmPassword) => {
    const payload = {
      reset_password_code: resetCode,
      password: newPassword,
      password_confirmation: confirmPassword,
    };
    const response = await apiService.post(
      "/customers/reset-password",
      payload
    );
    return response.data;
  },

  updatePassword: async (id, newPassword, confirmPassword) => {
    const payload = {
      id: id,
      password: newPassword,
      password_confirmation: confirmPassword,
    };
    const response = await apiService.post(
      // `/customers/change-password/${id}`,
      "/customers/change-password",
      payload
    );
    return response.data;
  },
};

export default PasswordService;
